import { getData } from "./GetData";

export const getPaymentData = async () => {
  const apiGatewayUrl = process.env.RAZZLE_API_GATEWAY_URL || window.env.RAZZLE_API_GATEWAY_URL;
  const mapperPM = process.env.MAPPER_PAYMENT_METHODS_AGROFYPAY || '';
  const paymentMethodsAgrofyPay = mapperPM.split(',').map(x => (
    {
      id: x.split('-')[0]?.trim(),
      code: x.split('-')[1]?.trim()
    }
  ));

  let data = await getData({ url: `${apiGatewayUrl}/payments/methods-types-all` })
    .then((response) => {
      return (response.status == 200) ? response.data[0] : [];
    }).catch(() => { return [] })
  

  const pricing = await getPricingData();
  data = mapPaymentMethods(data, paymentMethodsAgrofyPay, pricing)

  return [data, sellerPaymentMethods];
};

export const getPricingData = async () => {
  const apiGatewayAgrofypayUrl = process.env.RAZZLE_API_GATEWAY_AGROFYPAY_URL;

  return getData({ url: `${apiGatewayAgrofypayUrl}/api/openpass/paymentmethods` })
    .then((response) => {
      return (response.status === 200) ? response.data : [];
    }).catch(() => { return [] });
}

const sellerPaymentMethods = {
  Name: "Pagos a convenir",
  Description: "",
  Image: "",
  PaymentMethodTypes: [
    {
      PaymentMethodTypeId: 99,
      PositionOne: 1,
      PositionTwo: 1,
      Name: "Medios de pago de los vendedores",
      Description:
        "En Agrofy queremos ofrecerte la mayor cantidad de medios de pago posibles, para que puedas abonar tu compra a tu conveniencia. Por eso, en las sucursales online encontrarás financiación y alternativas de pago ofrecidas directamente por el vendedor.  Queremos recordarte que, en estos casos, Agrofy no participa ni forma parte del proceso de cobro de la operación, por lo que no se responsabiliza ni intervendrá en la resolución de temas relacionados a esta gestión (incluido pero no limitado a reembolsos/ devoluciones/ acreditación, etc.). Ante cualquier duda o consulta, podés escribirnos a info@agrofy.com.",
      DisplayDates: true,
      DisplayQuota: false,
      Comments: null,
      PaymentMethodTypeCode: null,
      Image: [],
      Rates: [],
      PaymentMethods: [],
      IsOnline: false,
      IsExternalCheckout: false,
    },
  ],
}

const mapPaymentMethods = (data, mappers, pricing) => {
  const newPaymentMethodTypes = data.PaymentMethodTypes.map(x =>
  (
    {
      ...x,
      PaymentMethods: x.PaymentMethods.map(pm => {
        const agrofyPayCode = mappers.find(x => x.id == pm.Id)?.code;
        const rates = agrofyPayCode ? pricing.find(x => x.code == agrofyPayCode)?.installmentPlans.map(ip => ip) : [];
        return (
          {
            ...pm,
            AgrofyPayCode: agrofyPayCode,
            Rates: rates
          }
        )
      }).sort((a, b) => parseFloat(a.Position) - parseFloat(b.Position))
    }
  )
  );
  return ({ ...data, PaymentMethodTypes: newPaymentMethodTypes });
}